import React from "react";

function DisplayComponent() {
  return <div>'DisplayComponent'</div>;
}

export default DisplayComponent;
